var _defs, _g, _path, _path2, _path3, _path4, _g2, _path5, _g3, _rect, _g4, _rect2, _g5, _rect3, _g6, _rect4, _g7, _rect5, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_text_stack",
    "data-name": "Layer 1 Text Stack",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 298.67 340.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .text-stack-cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .text-stack-cls-2, .text-stack-cls-3, .text-stack-cls-4, .text-stack-cls-5, .text-stack-cls-6, .text-stack-cls-7 {\n        stroke-width: 0px;\n      }\n\n      .text-stack-cls-2, .text-stack-cls-8, .text-stack-cls-9, .text-stack-cls-10, .text-stack-cls-11, .text-stack-cls-12, .text-stack-cls-13, .text-stack-cls-14, .text-stack-cls-15, .text-stack-cls-16, .text-stack-cls-17 {\n        fill: none;\n      }\n\n      .text-stack-cls-3 {\n        fill: #faa224;\n      }\n\n      .text-stack-cls-8, .text-stack-cls-13 {\n        stroke: #ec9a22;\n      }\n\n      .text-stack-cls-8, .text-stack-cls-14, .text-stack-cls-15, .text-stack-cls-17 {\n        stroke-miterlimit: 24.2;\n      }\n\n      .text-stack-cls-4 {\n        fill: #fbc4ac;\n      }\n\n      .text-stack-cls-9, .text-stack-cls-17 {\n        stroke: #80b9aa;\n      }\n\n      .text-stack-cls-18 {\n        clip-path: url(#clippath-1);\n      }\n\n      .text-stack-cls-19 {\n        clip-path: url(#clippath-4);\n      }\n\n      .text-stack-cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .text-stack-cls-21 {\n        clip-path: url(#clippath-2);\n      }\n\n      .text-stack-cls-22 {\n        clip-path: url(#clippath-7);\n      }\n\n      .text-stack-cls-23 {\n        clip-path: url(#clippath-6);\n      }\n\n      .text-stack-cls-24 {\n        clip-path: url(#clippath-5);\n      }\n\n      .text-stack-cls-10 {\n        stroke-miterlimit: 29.32;\n      }\n\n      .text-stack-cls-10, .text-stack-cls-16 {\n        stroke: #e66a45;\n      }\n\n      .text-stack-cls-11, .text-stack-cls-14 {\n        stroke: #1c929b;\n      }\n\n      .text-stack-cls-5 {\n        fill: #f37049;\n      }\n\n      .text-stack-cls-6 {\n        fill: #86c2b3;\n      }\n\n      .text-stack-cls-12, .text-stack-cls-15 {\n        stroke: #eebaa3;\n      }\n\n      .text-stack-cls-7 {\n        fill: #1d99a1;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7-text-stack"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-2",
    x: 0,
    y: 0,
    width: 298.67,
    height: 340.13
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-5",
    d: "M172.25,338.36l14.8.06.15-34.89h.15l26.96,35.01,14.8.07.25-56.94-14.8-.06-.15,34.81h-.15l-26.96-34.93-14.8-.07-.25,56.94ZM158.02,293.89l.06-12.54-32.4-.14-.25,56.94,32.4.14.05-12.54-17.6-.08.04-9.82,16.69.07.05-12.54-16.69-.07.04-9.52,17.6.08ZM85.23,292.97h2.49c2.87.02,5.36.35,7.47,1,2.11.64,3.16,2.77,3.14,6.38-.01,3.47-1.13,5.5-3.35,6.07-2.22.57-4.66.82-7.33.76h-2.49s.06-14.21.06-14.21ZM70.23,337.91l14.8.06.08-18.81,8.38.04c6.44.03,11.42-1.5,14.94-4.58,3.51-3.08,5.28-7.97,5.31-14.66.03-6.55-1.86-11.31-5.68-14.3-3.81-2.99-8.79-4.52-14.93-4.6l-22.66-.1-.25,56.94ZM32.06,293.26c4.43.02,8.21,1.56,11.35,4.63,3.13,3.07,4.69,6.57,4.67,10.5-.02,4.9-1.61,8.95-4.77,12.17-3.16,3.22-6.96,4.81-11.39,4.79-4.43-.02-8.21-1.65-11.35-4.88-3.13-3.24-4.69-7.3-4.67-12.18.02-3.93,1.6-7.41,4.77-10.44,3.16-3.03,6.95-4.56,11.39-4.6M32.12,278.99c-8.21-.04-15.52,2.66-21.94,8.1-6.42,5.44-9.65,12.46-9.68,21.07-.04,9.21,2.9,16.75,8.81,22.62,5.91,5.87,13.43,8.82,22.54,8.86,9.16.04,16.72-2.85,22.66-8.66,5.94-5.81,8.93-13.33,8.97-22.54.04-8.61-3.13-15.66-9.5-21.15-6.37-5.49-13.66-8.28-21.86-8.37v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-10",
    d: "M172.25,338.36l14.8.06.15-34.89h.15l26.96,35.01,14.8.07.25-56.94-14.8-.06-.15,34.81h-.15l-26.96-34.93-14.8-.07-.25,56.94ZM158.02,293.89l.06-12.54-32.4-.14-.25,56.94,32.4.14.05-12.54-17.6-.08.04-9.82,16.69.07.05-12.54-16.69-.07.04-9.52,17.6.08ZM85.23,292.97h2.49c2.87.02,5.36.35,7.47,1,2.11.64,3.16,2.77,3.14,6.38-.01,3.47-1.13,5.5-3.35,6.07-2.22.57-4.66.82-7.33.76h-2.49s.06-14.21.06-14.21ZM70.23,337.91l14.8.06.08-18.81,8.38.04c6.44.03,11.42-1.5,14.94-4.58,3.51-3.08,5.28-7.97,5.31-14.66.03-6.55-1.86-11.31-5.68-14.3-3.81-2.99-8.79-4.52-14.93-4.6l-22.66-.1-.25,56.94ZM32.06,293.26c4.43.02,8.21,1.56,11.35,4.63,3.13,3.07,4.69,6.57,4.67,10.5-.02,4.9-1.61,8.95-4.77,12.17-3.16,3.22-6.96,4.81-11.39,4.79-4.43-.02-8.21-1.65-11.35-4.88-3.13-3.24-4.69-7.3-4.67-12.18.02-3.93,1.6-7.41,4.77-10.44,3.16-3.03,6.95-4.56,11.39-4.6ZM32.12,278.99c-8.21-.04-15.52,2.66-21.94,8.1-6.42,5.44-9.65,12.46-9.68,21.07-.04,9.21,2.9,16.75,8.81,22.62,5.91,5.87,13.43,8.82,22.54,8.86,9.16.04,16.72-2.85,22.66-8.66,5.94-5.81,8.93-13.33,8.97-22.54.04-8.61-3.13-15.66-9.5-21.15-6.37-5.49-13.66-8.28-21.86-8.37v.08Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-3",
    d: "M228.74,223.83l.05-12.54-32.4-.14-.25,56.94,32.4.14.05-12.54-17.6-.08.04-9.82,16.69.07.06-12.54-16.69-.07.04-9.52,17.6.08ZM147.44,232.92l.1-21.98-14.8-.07-.25,56.94,14.8.06.1-23.34,21.37.09-.1,23.34,14.8.07.25-56.94-14.8-.07-.1,21.98-21.37-.09ZM109.86,223.31l13.95.06.06-12.54-44.77-.19-.05,12.54,13.95.06-.19,44.41,16.87.07.19-44.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-8",
    d: "M228.74,223.83l.05-12.54-32.4-.14-.25,56.94,32.4.14.05-12.54-17.6-.08.04-9.82,16.69.07.06-12.54-16.69-.07.04-9.52,17.6.08ZM147.44,232.92l.1-21.98-14.8-.07-.25,56.94,14.8.06.1-23.34,21.37.09-.1,23.34,14.8.07.25-56.94-14.8-.07-.1,21.98-21.37-.09ZM109.86,223.31l13.95.06.06-12.54-44.77-.19-.05,12.54,13.95.06-.19,44.41,16.87.07.19-44.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-4",
    d: "M172.43,197.68l14.8.06.15-34.89h.15l26.96,35.01,14.8.07.25-56.94-14.8-.06-.15,34.82h-.15s-26.96-34.93-26.96-34.93l-14.8-.07-.25,56.94ZM157.72,140.67l-14.8-.07-.25,56.94,14.8.06.25-56.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-15",
    d: "M172.43,197.68l14.8.06.15-34.89h.15l26.96,35.01,14.8.07.25-56.94-14.8-.06-.15,34.82h-.15s-26.96-34.93-26.96-34.93l-14.8-.07-.25,56.94ZM157.72,140.67l-14.8-.07-.25,56.94,14.8.06.25-56.94Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-6",
    d: "M215.1,83.5l13.95.06.05-12.54-44.77-.2-.05,12.54,13.95.06-.19,44.41,16.87.07.19-44.41ZM159.19,70.72l-.13,30.06c0,.3,0,.59,0,.87,0,.28,0,.57,0,.87-.07,3.42-.67,6.57-1.82,9.43-1.15,2.87-3.91,4.29-8.29,4.27-4.38-.02-7.13-1.47-8.25-4.34-1.12-2.88-1.7-6.02-1.73-9.45,0-.3,0-.59,0-.87,0-.28,0-.59,0-.94l.13-29.98-14.8-.06-.14,32.1c-.02,3.68.26,7.25.82,10.73.56,3.48,2.25,6.61,5.06,9.39,1.81,1.82,3.95,3.2,6.44,4.14,2.49.94,5.04,1.57,7.66,1.88.8.1,1.61.18,2.42.24.8.05,1.59.08,2.34.09.76,0,1.54-.02,2.34-.07.81-.05,1.61-.12,2.42-.22,2.62-.29,5.18-.9,7.67-1.82,2.5-.92,4.65-2.28,6.47-4.09,2.83-2.76,4.54-5.87,5.14-9.34.59-3.47.9-7.07.92-10.8l.14-32.02-14.8-.06ZM86.19,82.86c4.43.02,8.21,1.56,11.35,4.63,3.13,3.07,4.69,6.57,4.67,10.5-.02,4.9-1.61,8.95-4.77,12.17-3.16,3.22-6.96,4.81-11.39,4.79-4.43-.02-8.21-1.65-11.34-4.88-3.13-3.24-4.69-7.3-4.67-12.18.02-3.93,1.6-7.41,4.77-10.44,3.16-3.03,6.95-4.56,11.39-4.59M86.25,68.58c-8.21-.04-15.52,2.66-21.94,8.1-6.42,5.44-9.64,12.46-9.68,21.07-.04,9.21,2.9,16.75,8.81,22.62,5.92,5.87,13.43,8.82,22.54,8.86,9.16.04,16.72-2.85,22.66-8.66,5.94-5.81,8.93-13.33,8.97-22.54.04-8.61-3.13-15.66-9.5-21.15-6.37-5.49-13.66-8.28-21.86-8.37v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-17",
    d: "M215.1,83.5l13.95.06.05-12.54-44.77-.2-.05,12.54,13.95.06-.19,44.41,16.87.07.19-44.41ZM159.19,70.72l-.13,30.06c0,.3,0,.59,0,.87,0,.28,0,.57,0,.87-.07,3.42-.67,6.57-1.82,9.43-1.15,2.87-3.91,4.29-8.29,4.27-4.38-.02-7.13-1.47-8.25-4.34-1.12-2.88-1.7-6.02-1.73-9.45,0-.3,0-.59,0-.87,0-.28,0-.59,0-.94l.13-29.98-14.8-.06-.14,32.1c-.02,3.68.26,7.25.82,10.73.56,3.48,2.25,6.61,5.06,9.39,1.81,1.82,3.95,3.2,6.44,4.14,2.49.94,5.04,1.57,7.66,1.88.8.1,1.61.18,2.42.24.8.05,1.59.08,2.34.09.76,0,1.54-.02,2.34-.07.81-.05,1.61-.12,2.42-.22,2.62-.29,5.18-.9,7.67-1.82,2.5-.92,4.65-2.28,6.47-4.09,2.83-2.76,4.54-5.87,5.14-9.34.59-3.47.9-7.07.92-10.8l.14-32.02-14.8-.06ZM86.19,82.86c4.43.02,8.21,1.56,11.35,4.63,3.13,3.07,4.69,6.57,4.67,10.5-.02,4.9-1.61,8.95-4.77,12.17-3.16,3.22-6.96,4.81-11.39,4.79-4.43-.02-8.21-1.65-11.34-4.88-3.13-3.24-4.69-7.3-4.67-12.18.02-3.93,1.6-7.41,4.77-10.44,3.16-3.03,6.95-4.56,11.39-4.59ZM86.25,68.58c-8.21-.04-15.52,2.66-21.94,8.1-6.42,5.44-9.64,12.46-9.68,21.07-.04,9.21,2.9,16.75,8.81,22.62,5.92,5.87,13.43,8.82,22.54,8.86,9.16.04,16.72-2.85,22.66-8.66,5.94-5.81,8.93-13.33,8.97-22.54.04-8.61-3.13-15.66-9.5-21.15-6.37-5.49-13.66-8.28-21.86-8.37v.08Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-7",
    d: "M213.12.96l-14.8-.07-.25,56.94,32.55.14.05-12.54-17.75-.08.19-44.41ZM170.45.77l-14.8-.07-.25,56.94,32.55.14.05-12.54-17.75-.08.19-44.41ZM122.11,36.28l-12.31-.05,6.2-18.1h.15l5.96,18.15ZM126.06,47.63l3.66,9.91,15.78.07L124.3.57l-16.16-.07-22.15,56.85,15.71.07,3.97-9.88,20.39.09Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "text-stack-cls-14",
    d: "M213.12.96l-14.8-.07-.25,56.94,32.55.14.05-12.54-17.75-.08.19-44.41ZM170.45.77l-14.8-.07-.25,56.94,32.55.14.05-12.54-17.75-.08.19-44.41ZM122.11,36.28l-12.31-.05,6.2-18.1h.15l5.96,18.15ZM126.06,47.63l3.66,9.91,15.78.07L124.3.57l-16.16-.07-22.15,56.85,15.71.07,3.97-9.88,20.39.09Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-7",
    x: 241.47,
    y: 0.91,
    width: 56.7,
    height: 56.7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-11",
    x: 241.47,
    y: 0.91,
    width: 56.69,
    height: 56.7
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-6",
    x: 241.47,
    y: 70.99,
    width: 56.7,
    height: 56.69
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-9",
    x: 241.47,
    y: 70.99,
    width: 56.69,
    height: 56.7
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-4",
    x: 241.47,
    y: 140.97,
    width: 56.7,
    height: 56.7
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-12",
    x: 241.47,
    y: 140.97,
    width: 56.69,
    height: 56.7
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-3",
    x: 241.47,
    y: 211.28,
    width: 56.7,
    height: 56.7
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-13",
    x: 241.47,
    y: 211.28,
    width: 56.69,
    height: 56.7
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-5",
    x: 241.47,
    y: 281.65,
    width: 56.7,
    height: 56.7
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "text-stack-cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "text-stack-cls-16",
    x: 241.47,
    y: 281.65,
    width: 56.69,
    height: 56.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStack);
export default __webpack_public_path__ + "static/media/text-stack.da10b173c11832f567d7396d044ec260.svg";
export { ForwardRef as ReactComponent };